import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiUser, FiClock } = FiIcons;

const Reviews = () => {
  const [filter, setFilter] = useState('all');

  const reviews = [
    {
      author: "Mo",
      rating: 5,
      date: "4 months ago",
      review: "best shop in gateshead"
    },
    {
      author: "Karina Perfeito",
      rating: 1,
      date: "3 months ago",
      review: "Service is horrible staff ignore you"
    },
    {
      author: "Baban HM",
      rating: 5,
      date: "a year ago",
      review: "Staff are so nice and friendly. They have got a halal food,and fresh."
    },
    {
      author: "EKRMCHN TK",
      rating: 5,
      date: "a year ago",
      review: "Lamb shawarma is delicious and cheap. It is much better than German doner."
    },
    {
      author: "Faktea Lalfakzuala",
      rating: 5,
      date: "a year ago",
      review: "Friendly people. Great selection. Beef was excellent with great value for money"
    },
    {
      author: "John Angus",
      rating: 3,
      date: "7 years ago",
      review: "Good selection of goods on offer. No car park and very limited off street parking. Always appears busy no matter the time of day."
    },
    {
      author: "The Tarek",
      rating: 4,
      date: "5 years ago",
      review: "Good offers, quite diverse range of products. However, very narrow aisles and impossible for ppl with mobility issues to access"
    },
    {
      author: "derek murtaugh",
      rating: 5,
      date: "a year ago",
      review: "Excellent quality and good selection of products"
    },
    {
      author: "George Choumanidis",
      rating: 4,
      date: "5 years ago",
      review: "We do shop often here,as we buy good meat and veghies in good prices."
    },
    {
      author: "Riz K",
      rating: 4,
      date: "2 years ago",
      review: "Coastwood Road, a place where you can find everything of your day 2 day stuff. Especially hungry eaters"
    },
    {
      author: "tony olsen",
      rating: 5,
      date: "5 years ago",
      review: "Great staff very helpful cheap too"
    },
    {
      author: "Kati Perry",
      rating: 5,
      date: "6 years ago",
      review: "Good range of produce and decent prices."
    },
    {
      author: "Zaid Saleh Aseri",
      rating: 5,
      date: "a year ago",
      review: "Best halal and Asian food shop in gateshead"
    },
    {
      author: "Giuseppe Antonio Di Stefano",
      rating: 5,
      date: "4 years ago",
      review: "Kind staff and many Mediterranean products"
    },
    {
      author: "Victor Moyo",
      rating: 5,
      date: "2 years ago",
      review: "Timeless customer service!"
    }
  ];

  const filteredReviews = filter === 'all' 
    ? reviews 
    : reviews.filter(review => review.rating === parseInt(filter));

  const averageRating = reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length;
  const ratingCounts = [1, 2, 3, 4, 5].map(rating => 
    reviews.filter(review => review.rating === rating).length
  );

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <SafeIcon
        key={i}
        icon={FiStar}
        className={`h-4 w-4 ${i < rating ? 'text-accent-400 fill-current' : 'text-gray-300'}`}
      />
    ));
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-screen py-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={itemVariants} className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-secondary-600 via-primary-600 to-accent-600 bg-clip-text text-transparent mb-4">
            Customer Reviews
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See what our customers are saying about their experience at Gateshead Halal Food Store.
          </p>
        </motion.div>

        {/* Rating Summary */}
        <motion.div 
          variants={itemVariants}
          className="bg-white rounded-lg shadow-lg p-8 mb-8 border border-primary-200"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold bg-gradient-to-r from-secondary-600 to-primary-600 bg-clip-text text-transparent mb-2">
                {averageRating.toFixed(1)}
              </div>
              <div className="flex justify-center space-x-1 mb-2">
                {renderStars(Math.round(averageRating))}
              </div>
              <p className="text-gray-600">Based on {reviews.length} reviews</p>
            </div>
            <div className="space-y-2">
              {[5, 4, 3, 2, 1].map((rating) => (
                <div key={rating} className="flex items-center space-x-2">
                  <span className="text-sm w-8">{rating}</span>
                  <SafeIcon icon={FiStar} className="h-4 w-4 text-accent-400" />
                  <div className="flex-1 bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-gradient-to-r from-secondary-500 to-primary-500 h-2 rounded-full"
                      style={{
                        width: `${(ratingCounts[rating - 1] / reviews.length) * 100}%`
                      }}
                    />
                  </div>
                  <span className="text-sm w-8">{ratingCounts[rating - 1]}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Filter Buttons */}
        <motion.div variants={itemVariants} className="flex flex-wrap gap-2 mb-8">
          <button
            onClick={() => setFilter('all')}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              filter === 'all'
                ? 'bg-gradient-to-r from-secondary-600 to-primary-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            All Reviews
          </button>
          {[5, 4, 3, 2, 1].map((rating) => (
            <button
              key={rating}
              onClick={() => setFilter(rating.toString())}
              className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-1 ${
                filter === rating.toString()
                  ? 'bg-gradient-to-r from-secondary-600 to-primary-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <span>{rating}</span>
              <SafeIcon icon={FiStar} className="h-4 w-4" />
            </button>
          ))}
        </motion.div>

        {/* Reviews List */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredReviews.map((review, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow border border-primary-200"
              whileHover={{ y: -2 }}
            >
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-secondary-100 via-primary-100 to-accent-100 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiUser} className="h-5 w-5 text-primary-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">{review.author}</h3>
                  <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <SafeIcon icon={FiClock} className="h-3 w-3" />
                    <span>{review.date}</span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-1 mb-3">
                {renderStars(review.rating)}
              </div>
              <p className="text-gray-700">{review.review}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div 
          variants={itemVariants}
          className="text-center mt-16 bg-gradient-to-r from-secondary-600 via-primary-600 to-accent-600 rounded-lg p-8 text-white"
        >
          <h2 className="text-3xl font-bold mb-4">Experience It Yourself</h2>
          <p className="text-xl mb-6">
            Visit us today and see why customers love shopping at Gateshead Halal Food Store.
          </p>
          <a
            href="tel:+447460008191"
            className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-block shadow-lg"
          >
            Call +447460008191
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Reviews;